<script>
import RaSearchBox from "@/components/ra-search-box.vue";
import RaSelectButton from "@/components/ra-select-button.vue";
import {createMA, deleteMA, editMA, getMAList, toggleMAStatus} from "@/api/zipCode";
export default {
  components: {
    RaSearchBox,RaSelectButton
  },
  props:{
    areaCodeOption:{
      default: [],
    },
    provinceOption:{
      default: [],
    }
  },
  data(){
    return{
      metrAreaLoading:false,
      metrAreaList:[],
      metrAreaTotal:0,
      metrAreaPage:1,
      areaTitle:'Create a metropolitan area',
      areaCreatDialog:false,
      areaCreateForm:{
        ma_code:'',
        province:'',
        ma_name:"",
      },
      areaRulesForm:{
        ma_code: [
          { required: true, message: 'Metropolitan area code is required', trigger: 'change' }
        ],
        province: [
          { required: true, message: 'Province is required', trigger: 'change' }
        ],
        ma_name: [
          { required: true, message: 'MA Name is required', trigger: 'blur' },
        ]
      },
      metrAreaDeleteTitle:'',
      metrAreaDeleteDialog:false,
      metrAreaDelete:1,
      searchColumn:[
        {
          type: 'input',
          prop: 'ma_code',
          label: ' MA Code',
          placeholder: 'Search..',
        },
        {
          type: 'input',
          prop: 'ma_name',
          label: 'MA Name',
          placeholder: 'Search..',
        },
      ],
      selectDeleteItem:'',
      searchForm:{
        page:1,
        limit:10,
        ma_code:'',
        ma_name:'',
      }
    }
  },
  created() {
    this.getMAListHandle(this.searchForm)
  },
  methods:{
    getMAListHandle(parmas){
      this.metrAreaLoading = true
      getMAList(parmas).then(res => {
        this.metrAreaLoading = false
        if (res.code === 200) {
           this.metrAreaList = res.data.list
            this.metrAreaTotal = res.data.total
        }
      })
    },
    MetrAreahandleSizeChange(){

    },
    metrAreaActiveHandle(status, row) {
      this.selectDeleteItem = row
      this.metrAreaDelete = status;
      if (status == 1){
        this.metrAreaDeleteTitle = 'Deactivate this metropolitan area'
      }else if(status == 2){
        this.metrAreaDeleteTitle = 'Activate this metropolitan area'
      }
      this.metrAreaDeleteDialog = true
    },
    // 删除区域
    metrAreaDeleteHandle(status, row) {
      this.selectDeleteItem = row
      this.metrAreaDelete = status;
      this.metrAreaDeleteTitle = "Delete this metropolitan area"
      this.metrAreaDeleteDialog = true
    },
    // 编辑区域
    metrAreaEditHandle(row) {
      this.areaCreateForm = row
      this.selectDeleteItem = row
      this.areaTitle ='Edit a metropolitan area'
      this.areaCreatDialog = true
    },
    areaCloseClear(){
      this.areaCreateForm = {
        ma_code:'',
        province:'',
        ma_name:"",
      }
      this.$nextTick(()=>{
        this.$refs.matrRef.clearValidate()
      })
    },
    cancelAreaCreate(){
      this.areaCreatDialog = false
    },
    confirmAreaCreate(){
      this.$refs.matrRef.validate((valid) => {
        if (valid) {
          // 如果验证通过，执行提交逻辑
          if (this.areaTitle == 'Create a metropolitan area'){
            createMA(this.areaCreateForm).then(res=>{
                if (res.code == 200){
                  this.areaCreatDialog = false
                  this.getMAListHandle()
                  this.$message({
                    type:'success',
                    message:res.msg
                  })
                }else {
                  this.$message({
                    type:'error',
                    message:res.msg
                  })
                }
            })
          }else {
            editMA(this.areaCreateForm).then(res=>{
              if (res.code == 200){
                this.areaCreatDialog = false
                this.getMAListHandle()
                this.$message({
                  type:'success',
                  message:res.msg
                })
              }else {
                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
            })
          }
        } else {
          this.$message({
            message:"Some information missing",
            type:'warning'
          })
        }
      });


    },
    metrAreaConfirmDelete(){
      if (this.metrAreaDelete == 3){
        deleteMA({
          ma_code:this.selectDeleteItem.ma_code
        }).then(res=>{
            if (res.code == 200){
              this.$message({
                type:"success",
                message:"Successfully deleted"
              })
              this.metrAreaDeleteDialog = false
              this.areaCreatDialog = false
              this.getMAListHandle(this.searchForm)
            }else {
              this.$message({
                type:'error',
                message:res.msg
              })
            }
        })
      }else {
        toggleMAStatus({
          ma_code:this.selectDeleteItem.ma_code,
          status:this.selectDeleteItem.status == 1? 0: 1
        }).then(res=>{
          if (res.code == 200){
            this.$message({
              type:"success",
              message:res.msg
            })
            this.metrAreaDeleteDialog = false
            this.areaCreatDialog = false
            this.getMAListHandle(this.searchForm)
          }else {
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        })
      }

    },
    changeDropHandle(val){
      if (val == 'Delete'){
        this.metrAreaDelete = 3
        this.metrAreaDeleteTitle = "Delete this metropolitan area"
      }else if (val == 'Deactivate'){
        this.metrAreaDelete = 1
        this.metrAreaDeleteTitle = 'Deactivate this metropolitan area'
      }else{
        this.metrAreaDelete = 2
        this.metrAreaDeleteTitle = 'Activate this metropolitan area'
      }
      this.metrAreaDeleteDialog = true
    },
    searchHandler(parpms){
       this.getMAListHandle(parpms)
    }
  }
}
</script>

<template>
  <div>
    <ra-search-box
      class="mt-4"
      ref="areaSearch"
      id="areaSearch"
      :search-fields="searchColumn"
      @search="searchHandler"
    ></ra-search-box>
    <div class="tasksTable"  v-loading="metrAreaLoading">
      <div class="innerTop">
        <div class="outTable"  v-if="metrAreaList.length!= 0">
          <el-table
            :data="metrAreaList"
            style="width: 100%;font-weight: normal;">
            <el-table-column
              header-align="center"
              align="center"
              width="55">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1">
                  <img class="w-4" src="../assets/activate.png" alt="">
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="ma_code"
              label="MA Code"
              width="200px"
            >
            </el-table-column>
            <el-table-column
              prop="province"
              label="Province"
              width="200px"
            >
            </el-table-column>
            <el-table-column
              label="MA Name"
              prop="ma_name"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="actions"
              width="150"
              label="Actions">
              <template slot-scope="scope">
                <div class="action">
                          <span  v-if="scope.row.status == 1" @click="metrAreaActiveHandle(1,scope.row)">
                            <img src="../assets/zipCode/activate@2x.png" alt="">
                          </span>
                  <span  v-else @click="metrAreaActiveHandle(2,scope.row)">
                            <img src="../assets/zipCode/ban@2x.png" alt="">
                          </span>
                  <span  @click="metrAreaDeleteHandle(3,scope.row)">
                        <img src="../assets/zipCode/delete@2x.png" alt="">
                        </span>
                  <span @click="metrAreaEditHandle(scope.row)">
                          <img src="../assets/zipCode/edit@2x.png" alt="">
                        </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="empty">
          <div>
            <img src="../assets/list_blank.png" alt="">
            <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="btomPagin" >
      <ra-pagination
        :current-page="metrAreaPage"
        :list-length="metrAreaList.length"
        :total="metrAreaTotal"
        @pageChange="MetrAreahandleSizeChange"
      ></ra-pagination>
    </div>
    <!--新增编辑area弹框-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="areaTitle"
      :visible.sync="areaCreatDialog"
      top="5vh"
      @close="areaCloseClear"
      width="35%">
      <div>
        <el-form :model="areaCreateForm" label-position="top" :rules="areaRulesForm" status-icon ref="matrRef" :show-message="false">
          <el-form-item label=" Metropolitan area code" required prop="ma_code">
            <el-input placeholder="Select a Metropolitan area code" v-model="areaCreateForm.ma_code"></el-input>
          </el-form-item>
          <el-form-item label="Province" required prop="province">
            <el-select v-model="areaCreateForm.province" placeholder="Province">
              <el-option
                v-for="item in provinceOption"
                :key="item.code"
                :label="item.code"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" MA Name" required prop="ma_name">
            <el-input placeholder="Input a zone letter" v-model="areaCreateForm.ma_name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="float:left;" v-if="areaTitle === 'Edit a metropolitan area'">
<!--          <ra-select-button></ra-select-button>-->
          <ra-select-button :active_mes="areaCreateForm.status == 1 ? 'Deactivate' :'Activate'"
                                            @changeDropHandle="changeDropHandle"></ra-select-button>
        </div>
          <el-button type="success" round style="width: 80px;padding: 0"  @click="cancelAreaCreate" >Cancel</el-button>
          <el-button plain class="changeFocus" @click="confirmAreaCreate">Submit</el-button>
      </span>
    </el-dialog>
    <!--    delete-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="metrAreaDeleteTitle"
      :visible.sync="metrAreaDeleteDialog"
      width="35%">
      <div class="addInner" v-if="metrAreaDelete == 1" style="margin-top: 24px">
        Will you deactivate this metropolitan area? All zones under this MA will be inactive.
      </div>
      <div class="addInner" v-if="metrAreaDelete == 2" style="margin-top: 24px">
        Will you activate this metropolitan area? All zones under this MA will be inactive.
      </div>
      <div class="addInner" v-if="metrAreaDelete == 3" style="margin-top: 24px">
        Will you delete this metropolitan area?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain style="width: 80px" class="changeFocus"  @click="metrAreaDeleteDialog = false">No</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="metrAreaConfirmDelete">Yes</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
@import "../view/zipCode/zipCode";
</style>
